import React from "react";

/**
 * Sharda Power official wordmark logo. The asset is a horizontal SVG (≈14:1 ratio).
 * Use `kind="mark"` for square icon spots (sidebar collapsed, favicon stand-in) — falls
 * back to the dark navy tile with the wordmark center-fitted (matches icon-192.png).
 * Use `kind="wordmark"` (default) inside top-bar / sidebar header where horizontal space exists.
 *
 * `size` controls HEIGHT in px. Width auto-scales by the asset's natural ratio.
 */
export function Logo({ size = 32, kind = "wordmark", variant = "auto", className = "" }) {
  if (kind === "mark") {
    // square mark (navy tile + centered wordmark) for tight spots
    return (
      <img
        src="/icon-192.png"
        alt="Sharda Power"
        width={size}
        height={size}
        className={["select-none rounded-lg", className].join(" ")}
        style={{ width: size, height: size, objectFit: "contain" }}
        data-testid="brand-logo"
        draggable={false}
      />
    );
  }
  const src = variant === "light" ? "/logo-light.png" : "/logo.png";
  // Natural aspect ratio is ~14:1 (1024:82). Height drives, width auto.
  const naturalRatio = 1024 / 82;
  const width = Math.round(size * naturalRatio);
  return (
    <img
      src={src}
      alt="Sharda Power"
      height={size}
      width={width}
      className={["select-none", className].join(" ")}
      style={{ height: size, width: "auto", maxWidth: "100%", objectFit: "contain" }}
      data-testid="brand-logo"
      draggable={false}
    />
  );
}

export default Logo;
